import React from 'react';

import { useTranslation } from 'react-i18next';
import { Collapse } from '@bringg/react-components';

import styles from './user-domain-groups.module.scss';

export const UserDomainGroups: React.FC<{ usersGroupedByDomain: [string, Bringg.User[]][] }> = ({
	usersGroupedByDomain
}) => {
	const { t } = useTranslation();

	return (
		<Collapse defaultActiveKey={[]} className={styles.userDomainsCollapse} removeHeaderPadding removeContentPadding>
			{usersGroupedByDomain.map(([domain, domainUsers]) => (
				<Collapse.Panel
					key={domain}
					header={
						<div className={styles.userDomainHeader} data-test-id={`user-domain-header-${domain}`}>
							<span>{domain || t('UNKNOWN')}</span>
							<span className={styles.userDomainCount}>({domainUsers.length})</span>
						</div>
					}
					className={styles.userDomainPanel}
					data-test-id={`user-domain-group-${domain || 'unknown'}`}
				>
					<ul className={styles.userEmailList} data-test-id={`user-email-list-${domain}`}>
						{domainUsers.map(user => (
							<li key={user.id} data-test-id={`user-email-item-${user.id}`}>
								<a
									href={`/#/drivers/${user.id}`}
									target="_blank"
									rel="noopener noreferrer"
									data-test-id={`user-link-${user.id}`}
								>
									{user.name}
								</a>{' '}
								({user.email})
							</li>
						))}
					</ul>
				</Collapse.Panel>
			))}
		</Collapse>
	);
};
